import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import { withStyles, Typography, Grid, TextField, Paper, Button, Avatar, makeStyles } from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import LinearProgress from '@material-ui/core/LinearProgress';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import FormHelperText from '@material-ui/core/FormHelperText';
import { purple, green, red } from '@material-ui/core/colors';
import { Link } from 'react-router-dom';
import { useAlerts } from '../hooks/alerts-hooks';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    paperWrapper: { padding: theme.spacing(0), overflow: 'hidden', width: 400 },
    formWrapper: { padding: theme.spacing(4, 4) },
    avatarStyle: { backgroundColor: 'purple' },
    itemMargin: { margin: theme.spacing(1, 0) },
    green: {
      color: '#fff',
      backgroundColor: green[500],
      width: theme.spacing(3),
      height: theme.spacing(3),
      margin: theme.spacing(2),
    },
    red: {
      color: '#fff',
      backgroundColor: red[500],
      width: theme.spacing(3),
      height: theme.spacing(3),
      margin: theme.spacing(2),
    },
    new: {
      display: 'inline-flex',

    },
  };
});

const ColorButton = withStyles((theme) => {
  return {
    root: {
      color: theme.palette.getContrastText(purple[500]),
      backgroundColor: purple[500],
      '&:hover': {
        backgroundColor: purple[700],
      },
    },
  };
})(Button);

const Register = () => {
  const { alertSuccess, alertError } = useAlerts();
  const [ username, setUsername ] = useState('');
  const [ password, setPassword ] = useState('');
  const [ showPassword, setShowPassword ] = useState('');
  const [ confirmPassword, setConfirmPassword ] = useState('');
  const [ showConfirmPassword, setShowConfirmPassword ] = useState('');
  const [ legitPassword, setLegitPassword ] = useState(false);
  const [ legitEmail, setLegitEmail ] = useState(false);
  const [ email, setEmail ] = useState('');
  const [ terms, setTerms ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const classes = useStyles();

  const cognitoRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?\-“!@#%&/,><’:;|_~`])\S{8,99}$/;
  const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

  const onChangeUsername = (e) => {
    setUsername(e.target.value);
  };

  const onChangePassword = (e) => {
    setPassword(e.target.value);
    setLegitPassword(true);
    if (!cognitoRegex.test(e.target.value)) {
      setLoading(false);
      setLegitPassword(false);
    }
  };

  const handleClickShowPassword = (e) => {
    console.log(e);
    setShowPassword(!showPassword);
  };

  const onChangeConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleClickShowConfirmPassword = (e) => {
    console.log(e);
    setShowConfirmPassword(!showConfirmPassword);
  };

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
    setLegitEmail(true);
    if (!emailRegex.test(e.target.value)) {
      setLegitEmail(false);
    }
  };

  const handleTerms = (e) => {
    console.log(e);
    setTerms(!terms);
  };

  const handleOnClickRegistration = (event) => {
    event.preventDefault();
    setLoading(true);

    if (false === legitEmail) {
      setLoading(false);
      alertError('Email must be legit');
      return;
    }

    if (false === legitPassword) {
      setLoading(false);
      alertError('Password must contain: more than 8 characters, numbers, special characters, uppercase letters, lowecase letters');
      return;
    }

    if (false === terms) {
      setLoading(false);
      alertError('You must accept terms and conditions');
      return;
    }

    if (password !== confirmPassword) {
      alertError('Password does not match with Confirmed Password');
      setLoading(false);
    } else {
      console.log('email : ', email);
      console.log('username : ', username);
      setLoading(true);
      Auth.signUp({
        username,
        password,
        attributes: {
          email,
        },
      }).then((registrationDetails) => {
        console.debug(registrationDetails);
        setLoading(false);
        alertSuccess('User has been registered');
      }).catch((err) => {
        const { code, message } = err;
        setLoading(false);
        console.log('error signing up: ', code);
        alertError(message);
      });
    }
  };

  return (
    <Grid item align='center'>
      <Paper elevation={ 1 } className={ classes.paperWrapper }>
        { loading && <LinearProgress />}
        <Paper elevation={ 0 } className={ classes.formWrapper }>
          <form onSubmit={ handleOnClickRegistration }>
            <FormControl>
              <Grid align='center'>
                <Avatar className={ classes.avatarStyle }><AddCircleOutlineIcon /></Avatar>
                <h2>Registration Page</h2>
              </Grid>
              <TextField
                required
                className={ classes.itemMargin }
                variant='outlined'
                label='Username'
                placeholder='Enter Username'
                name='username'
                fullWidth
                onChange={ onChangeUsername }
              />
              <TextField
                error={ !legitEmail }
                required
                className={ classes.itemMargin }
                variant='outlined'
                label='Email'
                placeholder='Enter Email'
                name='email'
                fullWidth
                onChange={ onChangeEmail }
              />
              <FormControl required className={ classes.itemMargin } variant='outlined'>
                <InputLabel>Password</InputLabel>
                <OutlinedInput
                  label='Password'
                  placeholder='Enter Password'
                  id='outlined-adornment-password'
                  type={ showPassword ? 'text' : 'password' }
                  value={ password }
                  onChange={ onChangePassword }
                  endAdornment={ (
                    <InputAdornment position='end'>
                      <IconButton
                        aria-label='toggle password visibility'
                        onClick={ handleClickShowPassword }
                        edge='end'
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ) }
                  labelWidth={ 70 }
                />
              </FormControl>
              <FormControl required className={ classes.itemMargin } variant='outlined'>
                <InputLabel>Confirm Password</InputLabel>
                <OutlinedInput
                  label='Confirm Password'
                  placeholder='Enter Confirm Password'
                  id='outlined-adornment-password'
                  type={ showConfirmPassword ? 'text' : 'password' }
                  value={ confirmPassword }
                  onChange={ onChangeConfirmPassword }
                  endAdornment={ (
                    <InputAdornment position='end'>
                      <IconButton
                        aria-label='toggle password visibility'
                        onClick={ handleClickShowConfirmPassword }
                        edge='end'
                      >
                        {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ) }
                  labelWidth={ 70 }
                />
              </FormControl>
              { legitPassword && (
                <FormHelperText
                  variant='caption'
                  display='block'
                  gutterBottom
                  className={ classes.new }
                >
                  <Avatar className={ classes.green }><CheckCircleOutlineIcon /></Avatar>
                  Password must contain:more
                  than 8 characters,uppercase,lowercase letters,numbers,special characters
                </FormHelperText>
              )}
              { !legitPassword && (
                <FormHelperText
                  variant='caption'
                  display='block'
                  gutterBottom
                  className={ classes.new }
                >
                  <Avatar className={ classes.red }><HighlightOffIcon /></Avatar>
                  Password must contain:more
                  than 8 characters,uppercase,lowercase letters,numbers,special characters
                </FormHelperText>
              )}
              <FormControlLabel
                control={ (
                  <Checkbox
                    onChange={ handleTerms }
                    name='checkedB'
                    color='primary'
                  />
                ) }
                label='Accept terms and conditions'
              />
              <ColorButton
                disabled={ loading }
                className={ classes.itemMargin }
                type='submit'
                variant='contained'
                fullWidth
              >
                Register
              </ColorButton>
              <Typography>Already have account</Typography>
              <Typography>
                <Link to='/login'>Go back to login</Link>
              </Typography>
            </FormControl>
          </form>
        </Paper>
      </Paper>
    </Grid>
  );
};

export default Register;
